var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/CloudOff.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CloudOff = ({
  color = '#000',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_6222_160587)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 9.99984C16 8.23984 14.6334 6.81317 12.9 6.69317C12.4467 4.39317 10.4267 2.6665 8.00003 2.6665C7.11336 2.6665 6.2867 2.9065 5.5667 3.31317L6.56003 4.3065C7.0067 4.11317 7.4867 3.99984 8.00003 3.99984C10.0267 3.99984 11.6667 5.63984 11.6667 7.6665V7.99984H12.6667C13.7734 7.99984 14.6667 8.89317 14.6667 9.99984C14.6667 10.6598 14.3467 11.2332 13.86 11.5998L14.8 12.5398C15.5267 11.9265 16 11.0265 16 9.99984ZM2.47336 3.03984C2.21336 3.29984 2.21336 3.71984 2.47336 3.97984L3.8467 5.35317H3.5667C1.38003 5.5865 -0.273304 7.57984 0.0400298 9.87984C0.306697 11.8932 2.1267 13.3332 4.1467 13.3332H11.82L12.68 14.1932C12.94 14.4532 13.36 14.4532 13.62 14.1932C13.88 13.9332 13.88 13.5132 13.62 13.2532L3.41336 3.03984C3.15336 2.77984 2.73336 2.77984 2.47336 3.03984ZM4.00003 11.9998C2.5267 11.9998 1.33336 10.8065 1.33336 9.33317C1.33336 7.85984 2.5267 6.6665 4.00003 6.6665H5.15336L10.4867 11.9998H4.00003Z",
      fill: "#D9575F"
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_6222_160587",
      children: /*#__PURE__*/_jsx("rect", {
        width: "16",
        height: "16",
        fill: color
      })
    })
  })]
});